//config util document
export function get(selector, Root = document) {
    return Root.querySelector(selector);
}

export function getAll(selector, Root = document) {
    return Root.querySelectorAll(selector);
}